import factoryWithTypeCheckers from '../node_modules/prop-types/factoryWithTypeCheckers.es.js';

const require$$1 = factoryWithTypeCheckers;

export { require$$1 as default };
